var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-component",class:_vm.type,domProps:{"innerHTML":_vm._s(_vm.$t(_vm.msg))},on:{"click":function($event){return _vm.emmitClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }